import PropTypes from 'prop-types';

const Breadcrumb = {
  label: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
};

export default Breadcrumb;
